import { useEffect } from 'react';
import { getIn, useFormikContext } from 'formik';

const PetFormikFocusError: any = (props: any) => {
  const { errors, isSubmitting, isValidating } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValidating && !props.inform) {
      const errorKey = Object.keys(errors)[0];
      const errorElement = document.querySelector(`[data-fieldname=${errorKey}]`)?.nodeName === 'INPUT' || document.querySelector(`[data-fieldname=${errorKey}]`)?.nodeName === 'SELECT'
        ? document.querySelector(`[data-fieldname=${errorKey}]`) as HTMLElement
        : document.querySelector(`[data-fieldname=${errorKey}] input`) as HTMLElement;
      if (errorElement) {
        errorElement.focus();
        if (errorElement.getAttribute('type') === 'file' || errorElement.getAttribute('type') === 'radio') {
          const top = errorElement.parentElement ? errorElement.parentElement.offsetTop : errorElement.offsetTop;
          window.scroll({
            top: top
          });
        }
      }
    }
    if (isSubmitting && !isValidating && props.inform) {
      const errorKey = Object.keys(errors)[0];
      let errorIndex = null;
      if (getIn(errors, errorKey) && getIn(errors, errorKey).length > 0) {
        getIn(errors, errorKey).some((item: any, index: number) => {
          if (item !== undefined) {
            errorIndex = index;
            return true;
          }
          return false;
        });
      }
      const errorElement = document.querySelector(`[data-fieldname=${errorKey + '-' + errorIndex}]`)?.nodeName === 'INPUT'
        ? document.querySelector(`[data-fieldname=${errorKey + '-' + errorIndex}]`) as HTMLElement
        : document.querySelector(`[data-fieldname=${errorKey + '-' + errorIndex}] input`) as HTMLElement;
      if (errorElement) {
        const top = errorElement.parentElement ? errorElement.parentElement.offsetTop : errorElement.offsetTop;
        window.scroll({
          top: top
        });
      }
    }
  }, [errors, isSubmitting, isValidating, props.inform]);

  return null;
};

export default PetFormikFocusError;
